import * as React from "react";
import "../../../../assets/scss/components/toc/generic/tocNote/tocNoteDsk.scss";

export interface ITocNoteDskProps {}

const TocNoteDsk: React.FC<ITocNoteDskProps> = props => {
	return <div className="toc_note_dsk">{props.children}</div>;
};

export default TocNoteDsk;
